var withHTMLSubtitles = require('./withHTMLSubtitles');

module.exports = withHTMLSubtitles;
